module.exports = __webpack_public_path__ + "static/media/ePN.5a811fc3.png";